<template>
  <div class="c-app">
    <div class="container">
      <div id="btn-open-caja" class="d-flex justify-content-end pt-2 mt-2">
        <div class="btn-group btn-home me-2">
          <button
            type="button"
            class="btn btn-outline-main bg-main text-white"
            @click="mtdBackCampus"
          >
            <i class="fas fa-recycle"></i> Cambiar de Sede
          </button>
        </div>
      </div>
      <div class="row px-3" id="div_conte2">
        <div id="div_conte" class="col-md-10 mx-auto">
          <div class="bg-secondary text-white bg-opacity-10">
            <div class="text-center py-3 px-5 btn-home" id="scroll-div">
              <div class="row mt-2">
              </div>
              <div class="row">
                <button
                  class="border-0 rounded-3 col m-2 p-2 text-white"
                  @click="changePage('consumos')"
                >
                  <strong>CONSUMOS </strong>
                </button>
                <button
                  class="border-0 rounded-3 col m-2 p-2 text-white"
                  @click="changePage('maintenance')"
                >
                  <strong>MANTENIMIENTO</strong>
                </button>
                <button
                  class="border-0 rounded-3 col m-2 p-2 text-white"
                  @click="changePage('reporte_despacho')"
                >
                  <strong>REPORTE DE DESPACHO</strong>
                </button>
                <button
                  class="border-0 rounded-3 col m-2 p-2 text-white"
                  @click="changePage('psicotropicos')"
                >
                  <strong>PSICOTRÓPICOS</strong>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br /><br />
  </div>
</template>

<script>
export default {
  name: "homeQuimicoFarmaceutico",
  data() {
    return {
      page: null,
    };
  },
  props: {
    permiso: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    changePage(page) {
      this.$emit("changePage", page);
    },
    mtdBackCampus: function () {
      this.$emit("mtdBackCampus");
    },
  },
};
</script>

<style scoped>
@media (max-width: 415px) {
  #scroll-div {
    height: 140px;
  }
}

@media (max-width: 1024px) {
  #scroll-div {
    height: 535px;
  }
}

@media (max-width: 768px) {
  #scroll-div {
    height: 410px;
  }
}
</style>